import React from 'react';
import { StyledDiv } from '../styled-elements';

function NotificationsData() {
  
  return (
    <div className="App border">
    <div className="border-bottom m-0 pb-2 pt-2 row align-items-center">
      <div className="col-md-6 text-left">
        <p className="mb-0 font-weight-bold">Send Push Notifications</p>
      </div>
    </div>
    <div className=''>
    <div className='col-md-12 mb-5 mt-3 text-left'>
    <form className="row"><label className="col-md-1">Message : </label><textarea id="textarea" rows={4} cols={4} className="col-md-6 form-control pl-0"></textarea></form>
    </div>
   </div>
   <div className="align-items-baseline bg-white m-0 p-3 row"><div className="col-md-6 text-left"><button type="button" className="btn btn-primary font_size_13px pb-1 pl-3 pr-3 pt-1">Send</button></div></div>
  </div>
  );
}

export default NotificationsData;
